import { render, staticRenderFns } from "./DisponibilizarVendaDialog.vue?vue&type=template&id=972a1388&"
import script from "./DisponibilizarVendaDialog.vue?vue&type=script&lang=js&"
export * from "./DisponibilizarVendaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports